function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import NoteIcon from 'svg/note.svg';
import PolygonIcon from 'svg/polygon.svg';
import messages from '../messages';
import Time from '../partials/Time';
import styles from '../RelatedData.pcss';
const NoteTooltip = ({ noteResource })=>{
    useStyles(styles);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.relatedDataTooltip,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.relatedDataTooltip__content,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.relatedDataTooltip__title,
                    children: [
                        /*#__PURE__*/ _jsx(NoteIcon, {
                            className: styles.relatedDataTooltip__titleIcon
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.relatedDataTooltip__titleText,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.note.label))
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.relatedDataTooltip__separator
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.relatedDataTooltip__details,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.relatedDataTooltip__detailValue,
                            children: noteResource.content
                        }),
                        /*#__PURE__*/ _jsx(Time, {
                            timeSeriesResource: noteResource
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(PolygonIcon, {
                    width: "17",
                    height: "12",
                    className: styles.relatedDataTooltip__polygon
                })
            ]
        })
    });
};
export default NoteTooltip;
